module.exports = __webpack_public_path__ + "fonts/icomoon.1bf31a4e.woff";